import { Breakdown } from "@xola/ui-kit";
import { DateFormat, formatDate, now } from "common";
import React from "react";
import { LineItem, Purchase } from "types";
import { PaymentCardInfo } from "./PaymentCardInfo";
import { PaymentMethodInfo } from "./PaymentMethodInfo";
import { getColor } from "./utils";

export const RefundLineItem = ({ lineItem, purchase }: { lineItem: LineItem; purchase: Purchase }) => {
    return (
        <Breakdown.Item
            value={-1 * lineItem.amount}
            secondary={
                lineItem.createdAt
                    ? formatDate(lineItem.createdAt, DateFormat.DATE_SHORT)
                    : formatDate(now(), DateFormat.DATE_SHORT)
            }
            info={<PaymentCardInfo lineItem={lineItem} purchase={purchase} />}
            methodIcon={<PaymentMethodInfo lineItem={lineItem} />}
            color={getColor(lineItem)}
            data-testid="refund-line-item"
            classNames={{ info: "no-translate" }}
            className="!mr-[-10px]"
        >
            {lineItem.name}
        </Breakdown.Item>
    );
};
